import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './customer.reducer';

export const CustomerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const customerEntity = useAppSelector(state => state.customer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="customerDetailsHeading">
          <Translate contentKey="crawlerBackendApp.customer.detail.title">Customer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{customerEntity.id}</dd>
          <dt>
            <span id="customerType">
              <Translate contentKey="crawlerBackendApp.customer.customerType">Customer Type</Translate>
            </span>
          </dt>
          <dd>{customerEntity.customerType}</dd>
          <dt>
            <span id="customerStatus">
              <Translate contentKey="crawlerBackendApp.customer.customerStatus">Customer Status</Translate>
            </span>
          </dt>
          <dd>{customerEntity.customerStatus}</dd>
          <dt>
            <span id="sendToMandate">
              <Translate contentKey="crawlerBackendApp.customer.sendToMandate">Send To Mandate</Translate>
            </span>
          </dt>
          <dd>{customerEntity.sendToMandate}</dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.customer.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {customerEntity.createdTimestamp ? (
              <TextFormat value={customerEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customer.customerAccount">Customer Account</Translate>
          </dt>
          <dd>{customerEntity.customerAccount ? customerEntity.customerAccount.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customer.organisation">Organisation</Translate>
          </dt>
          <dd>{customerEntity.organisation ? customerEntity.organisation.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.customer.suppliers">Suppliers</Translate>
          </dt>
          <dd>
            {customerEntity.suppliers
              ? customerEntity.suppliers.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {customerEntity.suppliers && i === customerEntity.suppliers.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/customer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/customer/${customerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CustomerDetail;
